import { render, staticRenderFns } from "./dietz.vue?vue&type=template&id=14010ea4&lang=pug&"
import script from "./dietz.vue?vue&type=script&lang=js&"
export * from "./dietz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports